import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { firestorePlugin } from "vuefire";
import router from "./router";
import LoadScript from "vue-plugin-load-script";
import ajax from "vuejs-ajax";

Vue.use(firestorePlugin);
Vue.use(ajax);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  LoadScript,
  render: (h) => h(App),
}).$mount("#app");

window.$ = window.jQuery = require("jquery");
